import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { clearLoginFailedErrorMessage, loginFailed } from '@redux/actions/singleSignOn';
import { generateRegisterLoginError } from '@redux/epic/singleSignOn/utils';
import { postAsObservable } from '@services/genericService';

import { EVENT_METHOD } from '../../../../utils';
import { GET_LOGIN_OTP_USE_FOR_LOGIN_KEY } from './useGetLoginOtp';

const RESEND_LOGIN_OTP_ENDPOINT = '/OTP/GetOTPPhoneLoginAgain';

export const useResendLoginOtp = () => {
  const dispatch = useDispatch();

  return useCallback(
    (phoneValue, useFor = GET_LOGIN_OTP_USE_FOR_LOGIN_KEY) =>
      new Promise((resolve, reject) => {
        const params = {
          phoneNumber: phoneValue
        };

        return from(postAsObservable(RESEND_LOGIN_OTP_ENDPOINT, params))
          .pipe(
            map((res) => {
              if (res.data?.StatusCode === 0 && res.data?.Result) {
                if (useFor === GET_LOGIN_OTP_USE_FOR_LOGIN_KEY) dispatch(clearLoginFailedErrorMessage());

                return resolve(true);
              } else {
                if (useFor === GET_LOGIN_OTP_USE_FOR_LOGIN_KEY) {
                  dispatch(loginFailed(generateRegisterLoginError(res.data?.StatusReason || 'Failed', EVENT_METHOD.email)));

                  return resolve(false);
                } else {
                  return reject(res.data?.StatusReason);
                }
              }
            })
          )
          .subscribe({
            error: (error) => {
              if (useFor === GET_LOGIN_OTP_USE_FOR_LOGIN_KEY) {
                dispatch(loginFailed(generateRegisterLoginError(error?.message || 'Failed', EVENT_METHOD.email)));

                return resolve(false);
              } else {
                return reject(error?.message || 'Failed');
              }
            }
          });
      }),
    []
  );
};
